import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-current-schedule-tile',
    standalone: true,
    imports: [],
    templateUrl: './current-schedule-tile.component.html',
    styleUrl: './current-schedule-tile.component.scss'
})
export class CurrentScheduleTileComponent {
    @Input() eventName!: string;
    @Input() eventPlace!: string;
    @Input() dueDate!: string;
    @Input() birdAge!: string;
    @Input() assignedTo!: string;
    @Input() eventStatus!: string;
}
